export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0034.74ff2ed4.webp";